/**
 * Die Kamerabühnen im Browser (`platform/videoWeb.ts`, `fotoWeb.ts`, `qrScannerWeb.ts`) hängen
 * am `body`, ausserhalb des offenen Blatts. Radix deutete jeden Klick dort als „nach draussen"
 * und schloss das Blatt mitten in der Aufnahme (2026-11-01) — wie bei der Schlafecke.
 *
 * ⚠️ Die Bühnen schreiben das Merkmal als Zeichenkette: `platform/` importiert nichts aus `ui/`.
 */
export const BUEHNE = 'data-buehne';

export function istAusBuehne(ziel: EventTarget | null): boolean {
  return ziel instanceof Element && ziel.closest('[' + BUEHNE + ']') !== null;
}
